import _ from 'lodash'

import Chart_class from './chart_class.js'

// *****************************************************************************

export default class Chart_context {
  constructor(values) {
    let default_constructor = {
      title: 'Titre',
      type: 'bar',
      classes: [new Chart_class(), new Chart_class()],
      label: 'Label',
      xdisplay: true,
      ydisplay: true,
      is_quantitative: true,
      density_values: null,
    }
    let val = _.defaults(values, default_constructor)
    _.assign(this, val)
  }

  get_classes_label() {
    var res = []
    for (let i in this.classes) {
      res[i] = this.classes[i].label
    }
    return res
  }

  get_classes_values(which = 'val') {
    var res = []
    if (which === 'val') {
      for (let i in this.classes) {
        res[i] = this.classes[i].value
      }
    } else if (which === 'min') {
      for (let i in this.classes) {
        res[i] = this.classes[i].min
        if (res[i] === undefined) {
          res[i] = Number(this.classes[i].value) - 10
        }
      }
    } else if (which === 'max') {
      for (let i in this.classes) {
        res[i] = this.classes[i].max
        if (res[i] === undefined) {
          res[i] = Number(this.classes[i].value) + 10
        }
      }
    }
    return res
  }
}
